import carMarketPlaceholder from '~/assets/stubs/images/carMarket_placeholder.jpg';
import characterCreationPlaceholder from '~/assets/stubs/images/characterCreation_placeholder.jpg';
import characterSelectPlaceholder from '~/assets/stubs/images/characterSelect_placeholder.jpg';
import clothesShopPlaceholder from '~/assets/stubs/images/clothesShop_placeholder.jpg';
import defaultPlaceholder from '~/assets/stubs/images/default_placeholder.jpg';
import defaultNightPlaceholder from '~/assets/stubs/images/defaultNight_placeholder.jpg';
import dialogsPlaceholder from '~/assets/stubs/images/dialogs_placeholder.jpg';
import hobbyFishingPlaceholder from '~/assets/stubs/images/hobbyFishing_placeholder.jpg';
import homeBuyingPlaceholder from '~/assets/stubs/images/homeBuying_placeholder.jpg';
import paintPlaceholder from '~/assets/stubs/images/paint_placeholder.jpg';
import photoModePlaceholder from '~/assets/stubs/images/photoMode_placeholder.jpg';
import productShopPlaceholder from '~/assets/stubs/images/productShop_placeholder.jpg';
import spawnSelectPlaceholder from '~/assets/stubs/images/spawnSelect_placeholder.jpg';
import vehicleMoveDayPlaceholder from '~/assets/stubs/images/vehicleMoveDay_placeholder.jpg';
import vehicleMoveNightPlaceholder from '~/assets/stubs/images/vehicleMoveNight_placeholder.jpg';
import vehicleServicePlaceholder from '~/assets/stubs/images/vehicleService_placeholder.jpg';
import vehicleShopPlaceholder from '~/assets/stubs/images/vehicleShop_placeholder.jpg';

export enum PlaceholderType {
	Default = 'default',
	DefaultNight = 'defaultNight',
	Paint = 'paint',
	VehicleMoveDay = 'vehicleMoveDay',
	VehicleMoveNight = 'vehicleMoveNight',
	PhotoMode = 'photoMode',
	Dialogs = 'dialogs',
	CarMarket = 'carMarket',
	CharacterCreation = 'characterCreation',
	ClothesShop = 'clothesShop',
	HomeBuying = 'homeBuying',
	VehicleService = 'vehicleService',
	VehicleShop = 'vehicleShop',
	ProductShop = 'productShop',
	HobbyFishing = 'hobbyFishing',
	CharacterSelect = 'characterSelect',
	SpawnSelect = 'spawnSelect',
}

export const placeholderImages = {
	[PlaceholderType.Default]: defaultPlaceholder,
	[PlaceholderType.DefaultNight]: defaultNightPlaceholder,
	[PlaceholderType.Paint]: paintPlaceholder,
	[PlaceholderType.VehicleMoveDay]: vehicleMoveDayPlaceholder,
	[PlaceholderType.VehicleMoveNight]: vehicleMoveNightPlaceholder,
	[PlaceholderType.PhotoMode]: photoModePlaceholder,
	[PlaceholderType.Dialogs]: dialogsPlaceholder,
	[PlaceholderType.CarMarket]: carMarketPlaceholder,
	[PlaceholderType.CharacterCreation]: characterCreationPlaceholder,
	[PlaceholderType.ClothesShop]: clothesShopPlaceholder,
	[PlaceholderType.HomeBuying]: homeBuyingPlaceholder,
	[PlaceholderType.VehicleService]: vehicleServicePlaceholder,
	[PlaceholderType.VehicleShop]: vehicleShopPlaceholder,
	[PlaceholderType.ProductShop]: productShopPlaceholder,
	[PlaceholderType.HobbyFishing]: hobbyFishingPlaceholder,
	[PlaceholderType.CharacterSelect]: characterSelectPlaceholder,
	[PlaceholderType.SpawnSelect]: spawnSelectPlaceholder,
};
